import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllFoodsAndTacoFoods, getAllFoodsAndTaco4Foods } from '../../service/api';


// Fetch all Taco foods
export const fetchAllFoodsAndTacoFoods = createAsyncThunk(
  'food/fetchAllTacoFoods',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllFoodsAndTacoFoods();
      // console.log(JSON.stringify(response));
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
)

export const fetchAllFoodsAndTaco4Foods = createAsyncThunk(
  'food/fetchAllTaco4Foods',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllFoodsAndTaco4Foods();
      // console.log('taco4foods api return: ', response.data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
)
